<template>
  <!-- 首页底部 -->
  <div :class="{'home-footer':true,'alipay':env=='alipay'}">
    <img src="/static/images/logo2.png" class="footer-logo">
    <div class="friend-ship">
      <div>
        <span class="icon">
            <a href="https://weibo.com/mcake1893">
                <img src="/static/images/weibo.png">
            </a>
        </span>
        <span class="icon">
            <img src="/static/images/weixin.png" @click="showWxQrcode=!showWxQrcode">
        </span>
      </div>
      <div class="wx-qr-code" v-show="showWxQrcode">
        <img src="/static/images/wx_code.jpg">
      </div>
    </div>
    <p class="copyright">Copyright © 2012-{{(new Date()).getFullYear()}} 上海卡法电子商务有限公司 版权所有 <br> <a href="http://beian.miit.gov.cn" target="_blank">沪ICP备12022075号</a>  <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010702005582" target="_blank">沪公网安备31010702005582号</a></p>
  </div>
</template>
<script>
  export default {
    name: 'home-footer',
    data () {
      return {
        env: 'other',
        showWxQrcode: false
      }
    },
    mounted () {
      this.init()
    },
    methods: {
      init () {
        let browser = navigator.userAgent.toLowerCase()
        if (browser.match(/Alipay/i) == 'alipay') {
          this.env = 'alipay'
          this.showWxQrcode = false
        } else if (browser.match(/MicroMessenger/i) == 'micromessenger') {
          this.env = 'wechat'
          this.showWxQrcode = true
        } else {
          this.env = 'other'
          this.showWxQrcode = true
        }
      }
    }
  }
</script>
<style scoped>

  .home-footer {
    background-color: #000;
    height: 11rem;
    margin-top:0.8rem;
  }

  .home-footer.alipay {
    height: 6rem;
  }

  .footer-logo {
    width: 3rem;
    margin: 1.5rem 0 4.5rem;
  }

  .alipay .footer-logo {
    margin: 1.5rem 0 0;
  }

  .friend-ship {
    position: relative;
  }

  .alipay .friend-ship {
    display: none;
  }

  .friend-ship span.icon {
    margin: 0 .1rem;
  }

  .friend-ship a {
    display: inline-block;
  }

  .friend-ship img {
    width: 1rem;
    margin-right: .2rem;
  }

  .friend-ship img:last-child {
    margin-right: 0;
  }

  .copyright {
    color: #9c9c9c;
    font-size: .2rem;
    margin-top: .45rem;
  }

  .wx-qr-code {
    position: absolute;
    top: -3.7rem;
    left: 50%;
    margin-left: -1.5rem;
  }

  .wx-qr-code img {
    width: 3rem;
  }

</style>



// WEBPACK FOOTER //
// src/components/home/home-footer.vue